var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selectCard active-selectCard",on:{"click":_vm.handleClick}},[_vm._t("default"),_c('div',[_c('span',[_vm._v(_vm._s(_vm.label))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }